<template>
  <div class="flex flex-col md:flex-row items-center text-center md:text-left">
    <div class="shrink-0">
      <BonoHowItWorksNumber
        :text="index"
        class="shrink-0 w-20 h-20 text-amff-teal"
      />
    </div>
    <div>
      <h3 class="text-2xl font-bold">
        <slot name="title" />
      </h3>
      <p>
        <slot name="subtitle" />
      </p>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import BonoHowItWorksNumber from "./BonoHowItWorksNumber.vue";

export default defineComponent({
  components: {
    BonoHowItWorksNumber,
  },
  props: {
    index: {
      type: String,
      default: "1",
    },
  },
  setup() {
    return {};
  },
});
</script>
